import { render, staticRenderFns } from "./SpinningText.vue?vue&type=template&id=109f5e36&scoped=true"
import script from "./SpinningText.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinningText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpinningText.vue?vue&type=style&index=0&id=109f5e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109f5e36",
  null
  
)

export default component.exports